exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dia-body-sty[data-v-59900eaf]{display:-webkit-box;display:-ms-flexbox;display:flex}.dia-body-sty .r-lab[data-v-59900eaf]{width:15%}.dia-body-sty .r-lab>p[data-v-59900eaf]{font-size:.8vw;font-weight:bolder;color:#333;margin:10px 0}.dia-body-sty .r-lab .active[data-v-59900eaf]{color:#ec1c1c}.dia-body-sty .l-lab[data-v-59900eaf]{-webkit-box-flex:1;-ms-flex:1;flex:1}.dia-body-sty .l-lab .content-sty[data-v-59900eaf]{width:100%;height:500px;overflow-y:scroll;padding:10px 0 10px 10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59900eaf","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/auth/APIAuth/components/protocalNew/index.vue
// module id = eozl
// module chunks = 117